import BookReview from "./BookReview";
import { BookSerializersBookByline, UserBookSerializersUserBookReview } from "types/serializers";

export default function BookReviews({
  book,
  reviews,
  expandClass = "max-h-64",
}: {
  book: BookSerializersBookByline;
  reviews: UserBookSerializersUserBookReview[];
  expandClass?: string;
}) {
  return (
    <div className="divide-y divide-gray-100 dark:divide-gray-700">
      {reviews.map((userBook) => (
        <BookReview
          book={book}
          userBook={userBook}
          linkToReview
          className="py-6"
          expandClass={expandClass}
          key={`review-${userBook.userId}`}
        />
      ))}
    </div>
  );
}
